<style lang="scss">
.at-karney-left {
  align-items: center !important;
}
.at-karney-description h3 {
  font-size: 28px !important;
  color: #828282 !important;
}
.desc-info-box h3 {
  font-size: 26px !important;
  color: #828282 !important;
  margin: 0px 0 10px !important;
}
.contect-person-inner h3 {
  margin-bottom: 10px !important;
  font-size: 28px !important;
  color: #828282 !important;
}
.contact-details h3 {
  font-size: 18px !important;
  color: #333 !important;
  font-weight: 600 !important;
}
.single-contact {
  padding: 10px;
}
span.online {
  display: none !important;
}
.at-karney-wrap {
  height: 300px;
  overflow-y: scroll;
}
@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) {
  .booth-section {
    width: 960px !important;
    height: 516px !important;
  }
}
</style>
<template>
  <div @click="onClickHandler" class="page-effect">
    <!-- <TopMenu /> -->
    <!--<div class="top-header" style="padding: 15px 0; position: relative; z-index: 999; box-shadow: 0 0 10px rgba(0,0,0,0.4);">
      <h3
        style="padding: 0 20px; color: #000; font-weight: 500; font-size: 24px; font-family: 'Arial';margin: 0;"
      >
        <span>
          <router-link class="tab-link" v-bind:to="{ name: 'Expo'}">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
            width="30px"
            height="30px"
            class
          >
            <g>
              <g>
                <g>
                  <path
                    d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160    c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125    c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z    "
                    data-original="#000000"
                    class="active-path"
                    fill="#000000"
                  />
                </g>
              </g>
            </g>
          </svg></router-link>
        </span> Exhibitor Wall
      </h3>
    </div>-->
    <div
      class="booth-wrapper"
      style="
        width: 100%;
        height: calc(100vh - 70px);
        background: url(https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FExhibitors%2Fbooth-bg.jpg?alt=media&token=641f4b2c-9815-48df-ad48-bf84b12fc2ca)
          no-repeat scroll center center / cover;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      "
    >
      <div
        class="expo-menu"
        style="
          position: absolute;
          top: 10%;
          left: 6%;
          background: #fff;
          border-radius: 4px;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
        "
      >
        <ul style="margin: 0; padding: 0">
          <li style="none; display: block;">
            <router-link
              class="tab-link"
              v-bind:to="{ name: 'Expo' }"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 10px 18px;
                border-bottom: 1px solid #dfdfdf;
                color: #16171d;
                font-weight: 400;
                font-size: 1rem;
              "
            >
              <span style="margin-right: 10px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg> </span
              >Exhibitor Hall
            </router-link>
          </li>
          <li style="none; display: block;">
            <a
              v-bind:href="'/expoview/' + ExpPrv"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 10px 18px;
                border-bottom: 1px solid #dfdfdf;
                color: #16171d;
                font-weight: 400;
                font-size: 1rem;
              "
            >
              <span style="margin-right: 10px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 455 455"
                  style="enable-background: new 0 0 455 455"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                >
                  <g>
                    <path
                      d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M276.772,334.411  l-21.248,21.178L127.852,227.5L255.524,99.411l21.248,21.178L170.209,227.5L276.772,334.411z"
                      data-original="#000000"
                      class="active-path"
                      fill="#000000"
                    />
                  </g>
                </svg>
              </span>
              Previous Booth
            </a>
          </li>
          <li style="none; display: block;">
            <a
              v-bind:href="'/expoview/' + ExpNxt"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 10px 18px;
                color: #16171d;
                font-weight: 400;
                font-size: 1rem;
              "
            >
              <span style="margin-right: 10px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 455 455"
                  style="enable-background: new 0 0 455 455"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <path
                      d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M199.476,355.589  l-21.248-21.178L284.791,227.5L178.228,120.589l21.248-21.178L327.148,227.5L199.476,355.589z"
                      data-original="#000000"
                      class="active-path"
                      fill="#000000"
                    />
                  </g>
                </svg>
              </span>
              Next Booth
            </a>
          </li>
        </ul>
      </div>
      <div
        class="booth-section"
        style="
          margin-bottom: 90px;
          width: 1170px;
          height: 600px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        "
      >
        <!-- Hotspot mark-->
        <div id="dvhotspotter" class="hs-area"></div>
        <!-- Hotspot mark-->
      </div>
    </div>
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/Hotspot/css/jquery-hotspotter.min.css";
@import "../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";
</style>

<script>
import db from "../components/firebaseInit";
import router from "../router";
import store from "../store";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
let $ = jQuery;

// let lastVisible = null;
// let hasMore = true;
var self;
export default {
  components: {
    //TopMenu
  },
  data() {
    return {
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      MappedContacts: [],
      BroadcastData: [],
      exid: null,
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      ExhibitorData: [],
      DropFilter: [],
      HotspotSettings: [],
      GlobalKeysData: {
        // id: "SN1591285924312",
        // Name: "Opening Key Note",
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        // UserID: "84607270",
        //  eventID: this.eventId,
        // chanelID: "GB" + "_4733" + "_" + "SN1591285924312",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
    };
  },
  methods: {
    fetchExhibitor: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);
      db.collection(obj.eventcollectionname) //"OA_UAT_C1592010308300E1592010479212") //OA_UAT_C1591205467009E1591206650065")
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .where("ExhibitorId", "==", obj.selExhibitorID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.ExhibitorData.push({
              id: doc.id,
              Name: doc.data().Name,
              Logo: doc.data().Logo,
              Email: doc.data().Email,
              Category: doc.data().Category,
              BoothNo: doc.data().BoothNo,
              HotspotImageUrL: doc.data().HotspotImageUrL,
              Website: doc.data().Website,
              Profile: doc.data().Profile,
              Phone: doc.data().Phone,
              Image: doc.data().Logo,
              SocialLinks: doc.data().SocialLinks,
              MappedContacts: doc.data().MappedContacts,
              contactcount: doc.data().MappedContacts.length,
              Files: doc.data().Resources,
              fileLength: doc.data().Resources.length,
              ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
            });
            this.fetchHotspotSettings(
              doc.data().Category,
              doc.data().HotspotImageURL,
              this.ExhibitorData
            );
          });
        })
        .catch((error) => {
          alert(error);
          // console.log("Error getting documents: ", error);
        });
    },
    setFirebaseAppsettings: function () {
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      debugger;
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    fetchHotspotSettings: function (filterVal, imgurl, ExhData) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);
      this.showLoader();
      db.collection(obj.eventcollectionname) //"OA_UAT_C1592010308300E1592010479212") //OA_UAT_C1591205467009E1591206650065")
        .doc("ExhibitorHotspotSettings")
        .collection("Category")
        .where("Category", "==", filterVal)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.HotspotSettings.push({
              HtmlCode: doc.data().HtmlCode,
            });

            //$("#divLoading").show();
            var htmlcode = doc
              .data()
              .HtmlCode.replace("your image URL", imgurl);

            var facebook = ExhData[0].SocialLinks[0].Facebook;
            var twitter = ExhData[0].SocialLinks[1].Twitter;
            var linkedin = ExhData[0].SocialLinks[3].LinkedIn;

            var fbtrue = false;
            if (facebook !== undefined) {
              if (facebook === "") {
                fbtrue = false;
              } else {
                fbtrue = true;
              }
            } else {
              fbtrue = false;
            }

            var twittertrue = false;
            if (twitter !== undefined) {
              if (twitter === "") {
                twittertrue = false;
              } else {
                twittertrue = true;
              }
            } else {
              twittertrue = false;
            }

            var linkedintrue = false;
            if (linkedin !== undefined) {
              if (linkedin === "") {
                linkedintrue = false;
              } else {
                linkedintrue = true;
              }
            } else {
              linkedintrue = false;
            }

            var descriptionHTML =
              '<div class="at-karney-wrap">' +
              ' <div class="at-karney-inner" style="padding: 20px 20px 15px; display: flex; justify-content: space-between; align-items: center;">' +
              ' <div class="at-karney-left" style="display: flex; justify-content: flex-start; align-items: flex-start;width: 60%;">' +
              ' <div class="at-karney-logo" style="height: 80px; width: 150px; display: flex;justify-content: center; align-items: center; border: 1px solid #e8e8e8; margin-right: 20px;overflow: hidden;">' +
              ' <img src="' +
              ExhData[0].Logo +
              '" alt="Logo" style="width: 100%;"/>' +
              " </div>" +
              ' <div class="at-karney-description">' +
              ' <h3 style="font-size: 32px; font-weight: 600; color: #333;margin: 0;">' +
              ExhData[0].Name +
              "</h4>" +
              // ' <h4 style="font-size: 20px; font-wight: 400; color: #333;margin: 0;">' +
              // ExhData[0].Category +
              // "</h4>" +
              " </div></div>" +
              ' <div class="at-karney-right">' +
              ' <div class="social-ico" style="width: 40%; display: inline;">' +
              ' <ul style="margin: 0; padding: 0; display: flex; justify-content: flex-end; align-items: center;">';
            if (fbtrue !== false) {
              descriptionHTML =
                descriptionHTML +
                ' <li style="display: inline-block; list-style: none;">' +
                ' <a target="_blank" href="' +
                facebook +
                '" style="height: 45px; width: 45px; background: #046ee5; display: inline-block; text-align: center; border-radius: 50%; line-height: 50px; margin: 0 5px;">' +
                ' <img src="../images/facebook.svg"/></a>' +
                " </li>";
            }

            if (twittertrue !== false) {
              descriptionHTML =
                descriptionHTML +
                ' <li style="display: inline-block; list-style: none;">' +
                ' <a target="_blank" href="' +
                twitter +
                '" style="height: 45px; width: 45px; background: #1da1f2; display: inline-block; text-align: center; border-radius: 50%; line-height: 50px; margin: 0 5px;">' +
                ' <img src="../images/twitter.svg" />' +
                " </a>" +
                " </li>";
            }

            if (linkedintrue !== false) {
              descriptionHTML =
                descriptionHTML +
                ' <li style="display: inline-block; list-style: none;">' +
                ' <a target="_blank" href="' +
                linkedin +
                '" style="height: 45px; width: 45px; background: #333; display: inline-block; text-align: center; border-radius: 50%; line-height: 45px; margin: 0 5px;">' +
                ' <img src="../images/linkedin.svg"/>' +
                " </a>" +
                " </li>";
            }

            descriptionHTML =
              descriptionHTML +
              " </ul>" +
              " </div></div></div>" +
              ' <div class="desc-info-box" style="padding: 0 20px;">' +
              ' <h3 style="font-size: 32px; font-weight: 600; color: #333;margin: 0px 0 10px;">Description</h3>' +
              ' <p style="font-size: 16px; font-weight: 400; color: #333; line-height: 20px; margin: 0 0 20px;">' +
              ExhData[0].Profile +
              "" +
              " </p>" +
              ' <ul style="margin:20px 0 25px; padding: 0;">' +
              ' <li style="display: inline-flex; list-style: none; justify-content: flex-start; align-items: center;"><span style="margin-right: 10px;">' +
              ' <img src="../images/envelope.svg"/>' +
              ' </span><a href="mailto:' +
              ExhData[0].Email +
              '" style="display: inline-block; font-size: 16px; font-weight: 400; color: #333; margin-right: 20px;">' +
              ExhData[0].Email +
              "</a></li>" +
              ' <li style="display: inline-flex; list-style: none; justify-content: flex-start; align-items: center;"><span style="margin-right: 10px;">' +
              ' <img src="../images/contact.svg"/>' +
              ' </span><a href="tel:' +
              ExhData[0].Phone +
              '" style="display: inline-block; font-size: 16px; font-weight: 400; color: #333; margin-right: 20px;">' +
              ExhData[0].Phone +
              "</a></li>" +
              ' <li style="display: inline-flex; list-style: none; justify-content: flex-start; align-items: center;">' +
              ' <span style="margin-right: 10px;">' +
              ' <img src="../images/web.svg"/>' +
              " </span>" +
              ' <a href="' +
              ExhData[0].Website +
              '" target="_blank" style="display: inline-block; font-size: 16px; font-weight: 400; color: #333; margin-right: 20px;">' +
              ExhData[0].Website +
              "</a>" +
              " </li></ul></div></div>";

            var videoHTML =
              '<iframe width="560" height="315" src="' +
              ExhData[0].ShowcaseVideoURL +
              '"' +
              ' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"' +
              ' allowfullscreen=""></iframe>';

            var collateralHTML =
              '<div class="at-karney-wrap collateral-wrap">' +
              ' <div class="pdf-wrap" style="padding: 25px;">';

            for (let i = 0; i < ExhData[0].Files.length; i++) {
              var arr = ExhData[0].Files[i].split("%2F");
              var arr2 = arr[4]
                .replace("%20", " ")
                .replace("%20", " ")
                .replace("%20", " ")
                .replace("%20", " ")
                .replace(".pdf", "")
                .split("?");

              var filename = arr2[0];
              var URL = ExhData[0].Files[i];
              collateralHTML =
                collateralHTML +
                ' <div class="single-pdf" style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 15px;">' +
                ' <div class="pdf-ico" style="display: flex; justify-content: flex-start; align-items: center;">' +
                ' <img src="../images/pdf.svg"/>' +
                ' <a href="' +
                URL +
                '" target="_blank" data-tag="' +
                filename +
                '" style="color: #333; font-size: 18px; font-weight: 600;display: inline-block;margin-left: 15px; text-decoration: none">' +
                filename +
                "</a>" +
                " </div>" +
                ' <div class="pdf-button"><a href="' +
                URL +
                '" target="_blank" data-tag="' +
                filename +
                '" ><img src="../images/view.svg"/></a>' +
                // ' <button style="border: none; padding: 5px 15px; background: #852D2B;color: #fff; font-size: 16px; font-weight: 400;margin: 0 10px;border-radius: 4px;">View</button>' +
                // ' <button style="border: none; padding: 5px 15px; background: #852D2B;color: #fff; font-size: 16px; font-weight: 400;border-radius: 4px">Download</button>' +
                " </div></div>";
            }
            collateralHTML = collateralHTML + " </div></div>";

            var contactHTML =
              '<div class="at-karney-wrap">' +
              ' <div class="contect-person-inner" style="padding: 25px;">' +
              ' <h3 style="margin-top: 0;margin-bottom: 20px; font-size: 32px; font-weight: 600; color: #333;">Contact Person</h3>';
            for (let i = 0; i < ExhData[0].MappedContacts.length; i++) {
              var dp;
              if (ExhData[0].MappedContacts.ProfilePictureURL !== undefined) {
                if (ExhData[0].MappedContacts.ProfilePictureURL === "") {
                  dp = "../images/avtaar.png";
                } else {
                  dp = ExhData[0].MappedContacts.ProfilePictureURL;
                }
              } else {
                dp = "../images/avtaar.png";
              }

              contactHTML =
                contactHTML +
                '<div class="single-contact" style="display: flex; justify-content: space-between; align-items: center; padding: 15px; border-radius: 10px; box-shadow: 0 0 7px rgba(0,0,0,0.2);margin-bottom: 15px;">' +
                ' <div class="contact-left" style="display: flex; justify-content: flex-start; align-items: center;">' +
                ' <div class="contact-img-wrap" style="height: 80px; width: 80px;position: relative; margin-right: 15px">' +
                ' <div class="contact-img" style="height: 80px; width: 80px; display: flex; justify-content: center; align-items: center; overflow: hidden; border-radius: 50%;"><img src="' +
                dp +
                '" style="width: 100%;"/>' +
                " </div>" +
                ' <span class="online" style="height: 14px; width: 14px; display: inline-block; background: #29c303;   position: absolute; border-radius: 50%; bottom: 0px; right: 9px; z-index: 99999;border: 2px solid #fff;"></span>' +
                "</div>" +
                ' <div class="contact-details">' +
                ' <h3 style="color: #333; font-size: 24px; font-weight: 600; margin: 0;">' +
                ExhData[0].MappedContacts[i].FirstName +
                " " +
                ExhData[0].MappedContacts[i].LastName +
                "</h3>" +
                ' <h4 style="color: #333; font-size: 18px; font-weight: 300; margin: 0;">' +
                ExhData[0].MappedContacts[i].Designation +
                "</h4>" +
                " </div>" +
                " </div>" +
                ' <div class="contact-right">' +
                ' <ul style="margin: 0; padding: 0;">' +
                ' <li style="display: inline-block; list-style: none; margin-right: 15px;">' +
                ' <a href="#" data-tag="StartBroadcast" class="openBroadcast" onclick="StartBroadcast(\'' +
                this.GlobalKeysData.BroadcastStartURL +
                "','" +
                this.GlobalKeysData.videoParamsEncryptURL +
                "'," +
                " '" +
                this.GlobalKeysData.IsBroadcastInNewTab +
                "','" +
                ExhData[0].id +
                "','" +
                ExhData[0].Name +
                "'," +
                " '" +
                ExhData[0].MappedContacts[i].Name +
                "','" +
                ExhData[0].MappedContacts[i].AttendeeId +
                "'," +
                " '" +
                this.GlobalKeysData.broadcastbaseURL +
                "','" +
                this.GlobalKeysData.BroadcastStartURL +
                "'," +
                " '" +
                this.GlobalKeysData.BroadcastvalidityHours +
                "','" +
                this.GlobalKeysData.videoId +
                "'," +
                " '" +
                this.GlobalKeysData.BroadcastCertificate +
                "','" +
                this.GlobalKeysData.BroadcastID +
                "'," +
                " '" +
                this.GlobalKeysData.ChannelPrefix +
                "','" +
                this.GlobalKeysData.BroadcastSpeakerApiUrl +
                "'," +
                " '" +
                this.GlobalKeysData.BroadcastAttendeeApiUrl +
                "');return false;\">" +
                ' <img src="../images/video-call.svg"/>' +
                " </a>" +
                " </li>" +
                ' <li style="display: inline-block; list-style: none; margin-right: 15px;">' +
                ' <a href="mailto:' +
                ExhData[0].MappedContacts[i].Email +
                '">' +
                ' <img src="../images/envelope2.svg"/>' +
                " </a>" +
                " </li>" +
                // ' <li style="display: inline-block; list-style: none;">' +
                // ' <a href="">' +
                // ' <img src="../images/chat.svg"/>' +
                // " </a>" +
                // " </li>" +
                " </ul>" +
                " </div>" +
                " </div>";
            }
            contactHTML = contactHTML + "</div></div>";

            htmlcode = htmlcode.replace("@@@Description", descriptionHTML);
            htmlcode = htmlcode.replace("@@@Video", videoHTML);
            htmlcode = htmlcode.replace("@@@Collaterals", collateralHTML);
            htmlcode = htmlcode.replace("@@@Contacts", contactHTML);
            if (document.getElementById("dvhotspotter") !== null) {
              document.getElementById("dvhotspotter").innerHTML = htmlcode;
            }

            let externalScript = document.createElement("script");
            externalScript.setAttribute(
              // "src",
              // "https://ajax.googleapis.com/ajax/libs/jquery/1.8.3/jquery.min.js"
              "src",
              "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
            );
            externalScript.setAttribute("type", "text/javascript");
            document.body.appendChild(externalScript);

            let externalScript1 = document.createElement("script");
            externalScript1.setAttribute(
              // "type",
              // "https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/jquery-ui.min.js"

              "type",
              "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
            );
            externalScript1.setAttribute("type", "text/javascript");
            document.body.appendChild(externalScript1);

            let externalScript3 = document.createElement("script");
            externalScript3.setAttribute(
              "src",
              "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.js?alt=media"
            );
            externalScript3.setAttribute("type", "text/javascript");
            document.body.appendChild(externalScript3);

            let externalScript4 = document.createElement("script");
            externalScript4.setAttribute(
              "src",
              "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.min.js?alt=media"
            );
            externalScript4.setAttribute("type", "text/javascript");
            document.body.appendChild(externalScript4);

            let externalScript5 = document.createElement("script");
            externalScript5.setAttribute(
              "src",
              "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fother.js?alt=media"
            );
            externalScript5.setAttribute("type", "text/javascript");
            document.body.appendChild(externalScript5);
            this.hideLoader();
          });
        })
        .catch((error) => {
          alert(error);
          this.hideLoader();
          // console.log("Error getting documents: ", error);
        });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
  },
  mounted() {
    self = this;
    $("#btnAddUserView").click();
    $("#topmenu").show();
    if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }
    self.exid = this.$route.params.sid;
    self.setFirebaseAppsettings();
    self.showLoader();
    if (this.$route.params.sid !== undefined) {
      if (this.$route.params.sid !== "") {
        store.commit("addExhibitorID", self.exid);
      } else {
        router.push({ name: "ExhibitorsHall" });
      }
    } else {
      router.push({ name: "ExhibitorsHall" });
    }
    this.ExhibitorData = [];
    this.HotspotSettings = [];
    this.fetchExhibitor();
    self.hideLoader();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------Page Title-------------
    document.title = "Lobby - " + obj.eventname;
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
  },
  computed: {
    ExpPrv() {
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      arr = obj.exbList.split(",").sort();

      if (this.$route.params.sid !== undefined) {
        if (this.$route.params.sid !== "") {
          store.commit("addExhibitorID", this.$route.params.sid);
          selID = this.$route.params.sid;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      console.log(arr);
      console.log("currindex " + arr.indexOf(selID));
      if (arr.indexOf(selID) > 0) {
        console.log("prv " + arr[arr.indexOf(selID) - 1]);
        return arr[arr.indexOf(selID) - 1];
      } else {
        console.log("prv 0");
        return arr[arr.length - 1];
      }
    },
    ExpNxt() {
      debugger;
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      arr = obj.exbList.split(",").sort();

      if (this.$route.params.sid !== undefined) {
        if (this.$route.params.sid !== "") {
          store.commit("addExhibitorID", this.$route.params.sid);
          selID = this.$route.params.sid;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      if (arr.indexOf(selID) < arr.length - 1) {
        console.log("nxt " + arr[arr.indexOf(selID) + 1]);
        return arr[arr.indexOf(selID) + 1];
      } else {
        console.log("nxt 0");
        return arr[0];
      }
    },
  },
};
</script>
